import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TermoSaqueBeneficio } from '../models/termoSaqueBeneficio.model';
import { TermoEstadoCivil } from '../models/termoEstadoCivil.model';

export class TermoEstadoCivilService extends ApiService implements BaseService<TermoEstadoCivil>{

    private strAction = 'api/WebTempTermoEstadoCivil';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<TermoEstadoCivil[]> {
        return this.get<TermoEstadoCivil[]>(this.strAction + `/GetAll`);
    }

    deleteById(id: number) {
        return this.post(this.strAction + `/DeleteById?id=${id}`);
    }

    getById(id: number): Observable<TermoEstadoCivil> {
        return this.get(this.strAction + `/GetById/${id}`);
    }

    getByCpf(cpf : string): Observable<TermoEstadoCivil[]> {
        return this.get<TermoEstadoCivil[]>(this.strAction + `/GetByCpf?nrCpf=${cpf}`);
    }

    Put(TermoEstadoCivil: TermoEstadoCivil): Observable<TermoEstadoCivil> {
        return this.post<TermoEstadoCivil>(this.strAction + `/Put`, TermoEstadoCivil);
    }

}